var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopVine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 745,
    height: 342,
    viewBox: "0 0 745 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M563.648 118.902C582.514 123.88 589.54 109.051 589.54 109.051C589.54 109.051 590.115 92.6458 571.077 88.4184C552.024 84.1947 521.001 92.4035 521.001 92.4035C521.001 92.4035 544.796 113.921 563.662 118.899L563.648 118.902Z",
    fill: "#81C341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M589.478 108.782L533.734 95.1943",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M589.478 108.782L533.734 95.1943",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M586.933 108.219L573.613 95.9473",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M570.236 104.019L557.377 107.866",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M556.795 100.8L546.312 92.623",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M543.355 97.5778L537.137 99.1475",
    stroke: "black",
    strokeOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M563.648 118.902C582.514 123.88 589.54 109.051 589.54 109.051C589.54 109.051 590.115 92.6458 571.077 88.4184C552.024 84.1947 521.001 92.4035 521.001 92.4035C521.001 92.4035 544.796 113.921 563.662 118.899L563.648 118.902Z",
    fill: "#81C341",
    fillOpacity: 0.25
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M374.996 256.532C386.487 259.539 390.746 250.502 390.746 250.502C390.746 250.502 391.075 240.515 379.48 237.965C367.876 235.417 349 240.453 349 240.453C349 240.453 363.513 253.523 375.005 256.53L374.996 256.532Z",
    fill: "#81C341"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M390.706 250.34L356.754 242.138",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M390.706 250.34L356.754 242.138",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M389.155 250.002L381.031 242.548",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M378.985 247.464L371.162 249.822",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M370.802 245.522L364.41 240.557",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M362.615 243.576L358.832 244.539",
    stroke: "black",
    strokeOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M374.996 256.532C386.487 259.539 390.746 250.502 390.746 250.502C390.746 250.502 391.075 240.515 379.48 237.965C367.876 235.417 349 240.453 349 240.453C349 240.453 363.513 253.523 375.005 256.53L374.996 256.532Z",
    fill: "#81C341",
    fillOpacity: 0.25
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M739.514 71.0268C684.542 72.8307 662.083 72.065 614.04 82.7643C568.55 92.9019 543.572 107.531 528.834 117.612C501.379 136.394 491.846 154.901 459.419 187.509C457.119 189.822 429.524 216.765 397.617 235.819C309.605 288.363 195.613 283.708 154.716 270.676C148.09 268.566 142.851 260.317 117.789 254.948C100.906 251.326 75.8796 253.816 67.1342 253.88C23.9202 254.177 26.7188 227.635 27.3993 211.809C30.4467 141.532 -4.98465 100.185 6.44609 131.24C10.6525 142.657 12.8084 124.1 20.0104 173.015C22.3312 188.745 18.151 206.01 18.1751 214.569C18.2178 229.583 15.1838 250.16 35.1504 263.391C55.117 276.622 115.989 255.928 146.759 292.783C157.298 305.405 255.795 311.494 321.859 295.97C389.68 280.028 447.856 243.734 472.734 223.422C514.889 189.008 516.334 173.154 547.695 150.551C605.299 109.042 727.393 119.677 750.23 129.716C752.198 130.582 773.935 135.661 790.759 141.813C805.671 147.262 789.446 91.0146 777.832 74.6944C771.719 66.0965 763.351 70.2507 739.506 71.0382L739.514 71.0268Z",
    fill: "#5F9340"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M739.514 71.0268C684.542 72.8307 662.083 72.065 614.04 82.7643C568.55 92.9019 543.572 107.531 528.834 117.612C501.379 136.394 491.846 154.901 459.419 187.509C457.119 189.822 429.524 216.765 397.617 235.819C309.605 288.363 195.613 283.708 154.716 270.676C148.09 268.566 142.851 260.317 117.789 254.948C100.906 251.326 75.8796 253.816 67.1342 253.88C23.9202 254.177 26.7188 227.635 27.3993 211.809C30.4467 141.532 -4.98465 100.185 6.44609 131.24C10.6525 142.657 12.8084 124.1 20.0104 173.015C22.3312 188.745 18.151 206.01 18.1751 214.569C18.2178 229.583 15.1838 250.16 35.1504 263.391C55.117 276.622 115.989 255.928 146.759 292.783C157.298 305.405 255.795 311.494 321.859 295.97C389.68 280.028 447.856 243.734 472.734 223.422C514.889 189.008 516.334 173.154 547.695 150.551C605.299 109.042 727.393 119.677 750.23 129.716C752.198 130.582 773.935 135.661 790.759 141.813C805.671 147.262 789.446 91.0146 777.832 74.6944C771.719 66.0965 763.351 70.2507 739.506 71.0382L739.514 71.0268Z",
    fill: "url(#paint0_linear_6187_11628)",
    fillOpacity: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M669.55 147.405C659.643 130.614 671.996 119.832 671.996 119.832C671.996 119.832 687.617 114.826 696.849 131.987C706.081 149.163 706.607 181.226 706.607 181.226C706.607 181.226 679.457 164.182 669.549 147.39L669.55 147.405Z",
    fill: "#81C341"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M672.269 119.821L700.465 169.739",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M672.269 119.821L700.465 169.739",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M673.502 122.117L688.918 131.596",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M682.073 137.032L681.863 150.442",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M688.815 149.082L699.523 156.943",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M695.56 161.134L695.738 167.54",
    stroke: "black",
    strokeOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M669.55 147.405C659.643 130.614 671.996 119.832 671.996 119.832C671.996 119.832 687.617 114.826 696.849 131.987C706.081 149.163 706.607 181.226 706.607 181.226C706.607 181.226 679.457 164.182 669.549 147.39L669.55 147.405Z",
    fill: "#81C341",
    fillOpacity: 0.25
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M145.107 308.715C155.342 302.687 151.939 293.295 151.939 293.295C151.939 293.295 145.089 286.018 135.105 292.442C125.116 298.873 115.376 315.808 115.376 315.808C115.376 315.808 134.877 314.734 145.112 308.707L145.107 308.715Z",
    fill: "#81C341"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M151.796 293.209L122.039 311.498",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M151.796 293.209L122.039 311.498",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M150.463 294.069L139.449 294.573",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M141.494 299.491L137.649 306.701",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M134.344 303.924L126.316 304.955",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M127.192 308.357L125.207 311.719",
    stroke: "black",
    strokeOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M145.107 308.715C155.342 302.687 151.939 293.295 151.939 293.295C151.939 293.295 145.089 286.018 135.105 292.442C125.116 298.873 115.376 315.808 115.376 315.808C115.376 315.808 134.877 314.734 145.112 308.707L145.107 308.715Z",
    fill: "#81C341",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6187_11628",
    x1: 446.004,
    y1: 139,
    x2: 525.903,
    y2: 232.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#157E0B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopVine);
export default __webpack_public_path__ + "static/media/top_vine.b9f75012ea7a1207498e5bce07458b4d.svg";
export { ForwardRef as ReactComponent };